export default __webpack_public_path__ + "static/media/Quiken_Ofrecemos.cf6d121e.png";